import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure7 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            stacking: 'normal',
        }
    },
    exporting: {
        enabled: false
    },
    xAxis: [{
        tickWidth: 0,
        labels: {
            groupedOptions: [{
                        style: {
                            transform: 'unset'
                        },
                  }],
            style: {
                transform: 'translateX(11px)'
            },
            align: 'right'
        },
        categories: [
            {
                name: "Amérique du Nord et <br /> Europe",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Océanie",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Caraïbes",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Amérique centrale",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Amérique latine et Caraïbes",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie de l’Ouest",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Afrique du Nord",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie de l’Ouest et <br /> Afrique du Nord",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Afrique subsaharienne",
                categories: ["2021","2020"]
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Afrique",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie de l’Est",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie du Sud-Est",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie du Sud",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie centrale",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie de l’Est et Asie du Sud",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie centrale et Asie du Sud",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Asie",
                categories: ["2021","2020"]
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Monde",
                categories: ["2021","2020"]
            },
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
    }],
    yAxis: [{
        labels: {
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        	format: '{value}',
        gridLineWidth: 2,
        floor: 0,
        ceiling: 70,
        tickInterval: 10,
        title: {
            text: 'Pourcentage',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    
    series: [{
        name: 'Insécurité alimentaire modérée',
        color: '#ed7d31',
        data: [ 6.4, 6.6,  null,
                8.5, 9.4, null,
                33.5, 31.8,  null,
                26.1, 26.8, null,
                26.4,26.7,  null,
                24.1, 22.7,  null,
                22.7, 20.7,  null,
                23.4, 21.7, null,
                37.0, 36.5,  null,
                34.4, 33.6, null,
               5.2, 5.8, null,
              16.6, 15.5, null,
              19.6, 24.3, null,
              15.3, 13.2, null,
              8.4, 8.6, null,
              19.4, 23.8, null,
              14.2, 16.1, null,
              17.6, 18.6, ]
    }, {
        name: 'Insécurité alimentaire grave',
        color: '#cc3300',
        data: [ 1.5, 1.2 , null,
            4.5, 2.6,  null,
            30.5, 36.6,  null,
            8, 7.3, null,
            14.2, 12.8,  null,
            9.6, 9.1, null,
            11.3, 9.5, null,
            10.4, 9.3,  null,
            26.2, 25.3, null,
            23.4, 22.4, null,
            1, 2, null,
            4.1, 3.4, null,
           21, 18.9, null,
           4.9, 4.7, null,
           1.9,2.4, null,
           20.4, 18.4, null,
           10.5, 9.7, null,
           11.7, 10.9, ]
    }]
}
